// extracted by mini-css-extract-plugin
export default {"date":"datetime_date__dcmM6"};